export { ProductDetailsTitle } from './ProductDetailsTitle';
